import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { provideZoneChangeDetection } from '@angular/core';

if (environment.production && !localStorage.getItem('TEST_E2E')) {
  Sentry.init({
    release: 'patient@' + environment.version,
    dsn: 'https://697275486861d5d770b10bebf2ce5942@o4506711249649664.ingest.sentry.io/4506717995991040',
    environment: environment.env,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.browserApiErrorsIntegration({
        setTimeout: true,
        setInterval: true,
        requestAnimationFrame: true,
        XMLHttpRequest: true,
        eventTarget: true,
      }),
      Sentry.httpContextIntegration(),
      Sentry.browserSessionIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error']
      }),
      Sentry.contextLinesIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.functionToStringIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      })
    ],

    sendDefaultPii: true,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      environment.loginRedirect
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
  providers: [],
})
  .catch(err => console.error(err));
